import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const contactForm: Form<Client> = {
  key: 'contact',
  title: 'Kontaktaufbau',
  fields: [
    {
      key: 'date',
      label: 'Kontaktdatum',
      fieldTypes: 'date',
    },
    {
      key: 'typeOfInitialContact',
      label: 'Art der ersten Kontaktaufnahme',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        { value: 'byPhone', label: 'telefonisch' },
        { value: 'byPost', label: 'postalisch' },
        { value: 'sms', label: 'SMS' },
        { value: 'mail', label: 'E-Mail' },
        { value: 'messenger', label: 'Messenger' },
        { value: 'chat', label: 'Chat' },
        { value: 'videochat', label: 'Videochat' },
        { value: 'personally', label: 'persönlich' },
        { value: 'noContactPossible', label: 'keine Kontaktaufnahme möglich' },
      ],
    },
    {
      key: 'noConsultationRequest',
      label: 'kein Beratungswunsch',
      xsWidth: 12,
      fieldTypes: 'checkbox',
    },
  ],
};

export default contactForm;
